// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gtKnb","controlBar":"styles_controlBar__sqmOy","buttons":"styles_buttons__Or8+z","button":"styles_button__VVlq1"};